import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/rightArrowFilled.svg'


const _hoisted_1 = {
  class: "flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = { class: "inline-flex items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routesArray, (crumb, crumbIndex) => {
        return (_openBlock(), _createElementBlock("li", { key: crumbIndex }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: _normalizeClass([crumbIndex == (_ctx.routesArray.length-1)?'pointer-events-none':'', "crumbSize font-medium text-gray hover:text-primary"]),
                href: "#",
                onClick: ($event: any) => (_ctx.navigate(crumb))
              }, _toDisplayString(crumb.name), 11, _hoisted_4)
            ]),
            (crumbIndex !== (_ctx.routesArray.length-1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "w-2.5 h-2.5 mx-1.5 mt-1 text-gray-400"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}